import {svgIconWrapper} from '../svg-icon-wrapper';

import ProspifyRegular from './prospify-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <ProspifyRegular {...props} />;
}

SvgComponent.iconName = 'prospifyRegular';

export const ProspifyRegularIcon = svgIconWrapper(SvgComponent);
